const ReportTabTypes = {
  LIST: 0,
  FILTER: 1,
  FORM: 2,
  All: 3,
}

export { ReportTabTypes }
